import { FaWhatsapp } from "react-icons/fa";
import { Phone } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5567996508622?text=Ol%C3%A1%2C%20preciso%20de%20um%20guincho!";
const TEL_URL = "tel:+5567996508622";
const PHONE = "(67) 99650-8622";

export default function FloatingButtons() {
  return (
    <>
      {/* Floating WhatsApp - Bottom Right */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-button"
        className="fixed bottom-24 md:bottom-8 right-4 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-2xl animate-pulse-glow transition-transform hover:scale-110"
        aria-label="Chamar no WhatsApp"
      >
        <FaWhatsapp className="w-7 h-7" />
      </a>

      {/* Mobile Fixed Call Bar - Bottom */}
      <div
        data-testid="mobile-call-bar"
        className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      >
        <a
          href={TEL_URL}
          data-testid="mobile-call-button"
          className="flex items-center justify-center gap-3 bg-[#FFD700] text-black font-bold text-base uppercase tracking-wide py-4 w-full"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          <Phone className="w-5 h-5" />
          Ligar Agora: {PHONE}
        </a>
      </div>
    </>
  );
}
